// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gift-content[data-v-265545e2]{align-items:center;display:flex;flex-direction:column;text-align:center}.info[data-v-265545e2]{font-size:1rem}.info.code-info[data-v-265545e2]{border:1px solid #000;padding:.2rem;width:80%}.product-image[data-v-265545e2]{align-self:center;border-radius:12px;margin-top:1rem;width:70%}.code[data-v-265545e2]{color:#616e71;font-size:.8rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
